import React from 'react'
import {KTIcon} from '../../_metronic/helpers'

type Props = {
  filterSummary: string
  showReset?: boolean
  onReset?: () => void
  resetLabel?: string
}

/** Shared filter summary row for admin list pages. */
const ListFilterToolbar = ({
  filterSummary,
  showReset,
  onReset,
  resetLabel = 'Reset to today',
}: Props) => (
  <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-5 px-1'>
    <div className='d-flex flex-wrap align-items-center gap-2'>
      <span className='badge badge-light-primary fs-7 fw-semibold py-3 px-4'>
        <KTIcon iconName='filter' className='fs-6 me-2' />
        Showing: {filterSummary}
      </span>
      {showReset && onReset && (
        <button type='button' className='btn btn-sm btn-light-danger' onClick={onReset}>
          {resetLabel}
        </button>
      )}
    </div>
  </div>
)

export default ListFilterToolbar
